import { LicenseInfo } from '@mui/x-license';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { config } from 'appConfig';
import { App } from 'pages/App/App';
import { AppPosthogProvider } from 'components/providers/AppPosthogProvider';

import './index.css';

/*
 * * * * *
 * FONTS *
 * * * * *
 *
 * MUI default typography configuration only relies on 300, 400, 500, and 700 font weights.
 * https://mui.com/components/typography/
 *
 * These should probably be lazy imports.
 */

// ROBOTO
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// LATO
// FIXME: Lato does not support font-weight: 500. The app will fallback to 400 when used.
import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';

// POPPINS
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';

LicenseInfo.setLicenseKey(config.muiXProLicenseKey);

createRoot(document.getElementById('root')!).render(<StrictMode>{AppPosthogProvider(<App />)}</StrictMode>);
